import React, { useState } from "react";
import { Button, Upload, Spin, Modal } from "antd";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

export default function Register(props) {
  const { loading, photo, setPhoto, register, requirePhotoEditPassword } = props;

  const [showCamera, setShowCamera] = useState(false);

  return (
    <Spin spinning={loading}>
      <p>User is not registered. Register below</p>
      <div>
        {photo ? (
          <>
            <img
              style={{ width: 500, borderRadius: 6, marginBottom: 12 }}
              src={photo}
              alt=""
            />
            <br />
            <Button style={{ marginRight: "5px" }} type="primary" onClick={() => register()}>
              Register
            </Button>
          </>
        ) : null}
        {photo ? null : (
          <Button onClick={() => requirePhotoEditPassword(() => setShowCamera(true))}>
            Take Photo
          </Button>
        )}
        <Modal
          title="Take Photo"
          visible={showCamera}
          footer={
            <div style={{ textAlign: "left", fontSize: 14 }}>
              <strong>Panduan Foto:</strong>
              <ul style={{ paddingLeft: 18, marginTop: 8 }}>
                <li>Hadapkan wajah langsung ke depan kamera (jangan menyamping)</li>
                <li>Pastikan seluruh wajah terlihat jelas</li>
                <li>Gunakan pencahayaan yang cukup (hindari cahaya dari belakang)</li>
                <li>Lepaskan topi, masker, atau kacamata hitam</li>
              </ul>
            </div>
          }
          onCancel={() => setShowCamera(false)}
        >
          {showCamera && (
            <Camera
              width={500}
              onTakePhotoAnimationDone={dataUri => {
                setPhoto(dataUri);
                setShowCamera(false);
              }}
              isImageMirror={true}
            />
          )}
        </Modal>
        {/* <Upload
          accept=".jpg,.jpeg,.png,image/jpeg,image/png"
          showUploadList={false}
          beforeUpload={file => {
            const reader = new FileReader();
            reader.onloadend = () => {
              setPhoto(reader.result);
            };
            reader.readAsDataURL(file);
            return false;
          }}
        >
          <Button>Upload from file</Button>
        </Upload> */}
        {photo && (
          <Button type="danger" onClick={() => setPhoto(null)}>
            Clear Photo
          </Button>
        )}
      </div>
    </Spin>
  );
}

